import moment from "moment";
import { apiEndpoints } from "../shared/constants/api-constant";
import { hideLoader, showLoader } from "../store/currentPreferencesSlice";
import store from "../store/store";
import {
  ICase,
  IMasterTemplateMedication,
  ITemplateDataTypes,
} from "./interfaces/DataInterfaces";
import restApiService from "./restApiService";

export class caseRepository {
  static GetAssignedCases = async (): Promise<ICase[]> => {
    let result: ICase[] = [];
    await restApiService
      .get(
        `${apiEndpoints.CASES}/${moment()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")}`
      )
      .then((response) => {
        if (response?.Status === 200) {
          result = response?.data;
        }
      })
      .catch((error) => {
        console.log("exception on API call : " + error);
      });
    return result;
  };

  static GetMedicationHistory = async (caseId: number): Promise<[]> => {
    let result: [] = [];
    await restApiService
      .get(`history/${caseId}`)
      .then((response) => {
        if (response?.Status === 200) {
          result = response?.data;
        }
      })
      .catch((error) => {
        console.log("exception on API call : " + error);
      });
    return result;
  };

  static GetTelephoneOrders = async (
    caseId: number,
    setLoadig: (loading: boolean) => void
  ): Promise<[]> => {
    let result: [] = [];
    try {
      store.dispatch(showLoader());
      const response = await restApiService.get(
        `${apiEndpoints.TELEMEDICATIONS}/${caseId}`
      );
      if (response?.Status === 200) {
        result = response?.data;
      }
    } catch (error) {
    } finally {
      store.dispatch(hideLoader());
    }
    return result;
  };

  static getMasterTemplateList = async (): Promise<ITemplateDataTypes[]> => {
    let result: ITemplateDataTypes[] = [];
    await restApiService
      .get(apiEndpoints.ALLTEMPLATESLIST)
      .then((response) => {
        if (response?.Status === 200 && Array.isArray(response?.data)) {
          result = response?.data;
        }
      })
      .catch((error) => {});
    return result;
  };

  static getMasterTemplateMedications = async (
    templateId: number
  ): Promise<IMasterTemplateMedication[]> => {
    let result: IMasterTemplateMedication[] = [];
    await restApiService
      .get(`${apiEndpoints.TEMPLATEMEDICATIONS}/${templateId}`)
      .then((response) => {
        if (response?.Status === 200 && Array.isArray(response?.data)) {
          result = response?.data;
        }
      })
      .catch((error) => {});
    return result;
  };
}
